import { AvailabilitySurveyQuery_survey as IStatus } from '../../../../gql'
import { CovidStatus, IParams } from './types'

export function initialParams(status: IStatus | null): IParams {
  if (status) {
    const { aggregatedOpenSpotsCount, isOpen } = status
    const isEnrolling = aggregatedOpenSpotsCount ? aggregatedOpenSpotsCount > 0 : false

    return {
      isEnrolling,
      isOpen: !!isOpen,
    }
  }

  return { isOpen: true, isEnrolling: true }
}

export function statusFromParams(params: IParams): CovidStatus {
  if (!params) return CovidStatus.CLOSED
  if (params.isEnrolling && params.isOpen) return CovidStatus.OPEN_ENROLLING
  if (params.isOpen) return CovidStatus.OPEN_FULL
  return CovidStatus.CLOSED
}
